import { ref, Ref, watch } from "vue";
import { JSONContent } from "@tiptap/core";
import { sha1 } from "@/modules/crypto";
import { useDebounceFn } from "@vueuse/core";

export const useAutoSave = (
  content: Ref<JSONContent>,
  onSave: Promise<void>,
  delay = 3000
) => {
  let prevSha1 = "";
  const status = ref<"done" | "pending">("done");
  const debouncedSave = useDebounceFn(async () => {
    const res = await onSave();
    status.value = "done";
    return res;
  }, delay);

  watch(content, async (newContent) => {
    if (!newContent) {
      return;
    }
    const currentSha1 = await sha1(JSON.stringify(newContent));
    // 1. 如果当前的sha1和上一次的sha1相同，说明内容没有变化，不需要保存
    if (currentSha1 === prevSha1) {
      return;
    }
    // 2. 初始化的时候，prevSha1为空，不需要保存
    if (!prevSha1) {
      prevSha1 = currentSha1;
      return;
    }
    // 3. 保存
    prevSha1 = currentSha1;
    status.value = "pending";
    await debouncedSave();
  });
  return { status };
};
